"use strict";

exports.__esModule = true;
exports.updatePlantStateActivitiesWithFormData = updatePlantStateActivitiesWithFormData;
var _excluded = ["states"];
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/** Given some form data, update the plant state activities data with the modified values */
function updatePlantStateActivitiesWithFormData(formData, _ref) {
  var activities = _ref.activities,
    mapping = _ref.mapping,
    states = _ref.states;
  var formDataStates = formData.states,
    activity = _objectWithoutPropertiesLoose(formData, _excluded);

  // 1. Remove the old activity with the id and add the new one
  var newActivities = activities.filter(function (a) {
    return a.id !== formData.id;
  });
  newActivities.unshift(activity);

  // 2. Update mappings
  var newMappings = mapping.map(function (m) {
    return Object.assign({}, m);
  });
  formDataStates.forEach(function (state) {
    var stateMap = newMappings.find(function (map) {
      return map.stateId === state.id;
    });
    // Shouldn't ever not have one but just in case patch the mapping with this state
    if (!stateMap) {
      stateMap = {
        stateId: state.id,
        activities: []
      };
      newMappings.push(stateMap);
    }

    // filter out if we already have it mapped so we can assume we just put a new one in next
    stateMap.activities = stateMap.activities.filter(function (activityMap) {
      return activityMap.id !== activity.id;
    });
    if (state.active === true) {
      stateMap.activities.push({
        rank: state.rank,
        id: activity.id,
        forceComment: state.forceComment,
        userAction: state.userAction
      });
    }
  });
  newActivities.forEach(function (newActivity) {
    return delete newActivity["selectedDevices"];
  });
  return {
    activities: newActivities,
    mapping: newMappings,
    states: states
  };
}